import { ReactComponent as ValidErrorSVG } from 'assets/svg/valid-error.svg';

export default function ValidErrorIcon() {
  return (
    <span className="valid-status error">
      <ValidErrorSVG />
    </span>
  );
}
